interface Window {
  dataLayer: any;
}

export class IncubetaClickToCallEvents {
  private readonly _ctcId: string = "clickToCallHeaderEvent";
  private readonly _ctcClassPrepend: string = "callNowClass";

  public constructor() {
    this.ClickToCallTagging();
  }

  private ClickToCallTagging() {
    let phoneNumber = null;
    let department = null;

    // mobile header
    const mobileCtcHeader = document.querySelector(
      `#${this._ctcId}`
    ) as HTMLAnchorElement;
    if (mobileCtcHeader) {
      phoneNumber = mobileCtcHeader.querySelector(
        `.${this._ctcClassPrepend}`
      )?.innerHTML;
      department = mobileCtcHeader.dataset.department;
      this.BuildEventListeners(mobileCtcHeader, department);
    }

    // VDP
    const vdpPhoneNumbers = Array.from(document.querySelectorAll("li")).filter(
      (elem) => elem.classList.value.includes("vdp-phone-")
    );
    vdpPhoneNumbers.forEach((elem) => {
      const innerText = elem.innerText || elem.textContent;
      if (innerText !== "" && innerText !== " ") {
        const callNowElem = elem.querySelector("a");
        phoneNumber = callNowElem.innerHTML;
        department = callNowElem.previousSibling.textContent;
        this.BuildEventListeners(callNowElem, department);
      }
    });

    const phoneDetailsDiv = document.querySelector("#phone-details");
    if (phoneDetailsDiv?.querySelector("table")) {
      // /hours.aspx
      const phoneNumberAnchors = Array.from(
        phoneDetailsDiv.querySelectorAll("a")
      );
      phoneNumberAnchors.forEach((elem) => {
        phoneNumber = elem.innerHTML;
        department = elem
          .closest("tr")
          ?.querySelector(".phonelabel")?.innerHTML;
        this.BuildEventListeners(elem, department);
      });
    } else if (phoneDetailsDiv) {
      // /contactus.aspx
      const phoneNumberAnchors = Array.from(
        phoneDetailsDiv.querySelectorAll("a")
      );
      phoneNumberAnchors.forEach((elem) => {
        phoneNumber = elem.innerHTML;
        department = elem.parentElement.querySelector("strong")?.innerHTML;
        this.BuildEventListeners(elem, department);
      });
    }

    // /aboutus.aspx
    const callNowClassSpans = Array.from(
      document.querySelectorAll("span")
    ).filter(
      (elem) =>
        elem.classList.value.includes(this._ctcClassPrepend) &&
        elem.parentElement.tagName === "A" &&
        elem.parentElement.id !== this._ctcId
    );
    callNowClassSpans.forEach((elem) => {
      phoneNumber = elem.innerHTML;
      department = elem.parentElement.previousElementSibling?.innerHTML;
      this.BuildEventListeners(
        elem.parentElement as HTMLAnchorElement,
        department
      );
    });
  }

  private BuildEventListeners(element: HTMLAnchorElement, department: string) {
    element.addEventListener("click", () => {
      if (department) {
        this.BuildTaggingScriptClickToCall(department);
      }
    });
  }

  private BuildTaggingScriptClickToCall(department: string) {
    const dataObject = {
      event: `phone_${department.toLocaleLowerCase()}`,
    };
    window.dataLayer.push(dataObject);
  }
}
